const BASE_ROUTE = "/personal-accident";
export const QUICK_QUOTE_ROUTE = `${BASE_ROUTE}/`;
export const PRODUCT_LISTING_PAGE_ROUTE = `${BASE_ROUTE}/products-list`;
export const POLICY_HIGHLIGHT_PAGE_ROUTE = `${BASE_ROUTE}/product-details`;
export const CREATE_QUOTE_PAGE_ROUTE = `${BASE_ROUTE}/product`;
export const PROPOSAL_CREATION_PAGE_ROUTE = `${BASE_ROUTE}/proposal-creation`;
export const PAYMENT_OPTIONS_PAGE_ROUTE = `${BASE_ROUTE}/payment-options`;
export const PAYMENT_PAGE_FOR_CUSTOMER_ROUTE = `${BASE_ROUTE}/payment`;
export const PAYMENT_STATUS_ROUTE = `${BASE_ROUTE}/payment-status`;
export const POLICY_STATUS_ROUTE = `${BASE_ROUTE}/policy-status`;
export const THANK_YOU_PAGE_ROUTE = `${BASE_ROUTE}/thank-you`;
